module.exports = __webpack_public_path__ + "img/fail-connection.9eb1b306.svg";